import { Component } from "@angular/core";
import { each } from "lodash";

@Component({
  selector: "fihe-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  constructor() {
    window["fi_url"] = window.location.pathname + window.location.search;
  }

  ngOnInit() {
    this.fetch();
    window["jQuery"]("body").on("click", ".favorite-link a", (e) => {
      var $self = window["jQuery"](e.currentTarget),
        id = $self.closest(".favorite-link").data("dienstleisterId");

      var url = $self.find("span:eq(0)").data("addUrl");
      if ($self.hasClass("is-active")) {
        url = $self.find("span:eq(1)").data("addUrl");
      }

      window["jQuery"].ajax({
        url: url,
        success: this.fetch.bind(this),
        error: this.fetch.bind(this),
      });

      try {
        var name = "-";
        if (window["jQuery"]('h1[itemprop="name"]').length > 0) {
          name = window["jQuery"]('h1[itemprop="name"]').text();
        } else if ($self.closest(".details").length > 0) {
          name = $self.closest(".details").find(".h3.name").text();
        } else {
          name = $self.data("addUrl");
        }

        if (window["dataLayer"]) {
          window["dataLayer"].push({
            custom_event_category: "Favoriten",
            custom_event_action: "Click",
            custom_event_label: name,
            custom_event_value: 1,
            event: "custom_event",
          });
        }
      } catch (e) {
        console.error(e);
      }
    });

    window["jQuery"]("body").on("favcheck", () => {
      this.fetch();
    });
  }

  fetch() {
    window["jQuery"].ajax({
      url: "/?type=1006",
      dataType: "json",
      success: this.fetchDone.bind(this),
    });
  }

  fetchDone(e) {
    window["updateListAll"] && window["updateListAll"](e);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts